import React, { useState } from 'react';

export default function BotControls() {
  // Stati per gestire l'hover dei singoli bottoni
  const [hoverStart, setHoverStart] = useState(false);
  const [hoverStop, setHoverStop] = useState(false);

  const sendCommand = async (action) => {
    try {
      const res = await fetch(`/api/${action}-bot`, { method: 'POST' });
      const data = await res.json();
      alert(data.message || data.error);
    } catch (err) {
      alert("Errore di connessione al server");
    }
  };

  // Stile base comune per i bottoni
  const buttonBaseStyle = {
    padding: '12px 24px',
    border: 'none',
    borderRadius: '8px',
    color: 'white',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '15px',
    transition: 'all 0.2s ease-in-out', // Transizione fluida
  };

  const startStyle = {
    ...buttonBaseStyle,
    backgroundColor: '#22c55e',
    transform: hoverStart ? 'scale(1.05)' : 'scale(1)',
    boxShadow: hoverStart ? '0 4px 15px rgba(34, 197, 94, 0.4)' : 'none',
  };

  const stopStyle = {
    ...buttonBaseStyle,
    backgroundColor: '#ef4444',
    transform: hoverStop ? 'scale(1.05)' : 'scale(1)',
    boxShadow: hoverStop ? '0 4px 15px rgba(239, 68, 68, 0.4)' : 'none',
  };

  return (
    <div style={{ 
      marginTop: '20px', 
      padding: '20px', 
      background: '#1e293b', 
      borderRadius: '12px',
      border: '1px solid #334155' 
    }}>
      <h3 style={{ color: '#94a3b8', marginTop: 0, fontSize: '14px', textTransform: 'uppercase', letterSpacing: '1px' }}>
        Controllo Remoto
      </h3>
      <div style={{ display: 'flex', gap: '15px', marginTop: '15px' }}>
        
        <button 
          onClick={() => sendCommand('start')} 
          onMouseEnter={() => setHoverStart(true)}
          onMouseLeave={() => setHoverStart(false)}
          style={startStyle}
        >
          <span style={{ fontSize: '18px' }}>▶</span> Start Bot
        </button>
        
        <button 
          onClick={() => sendCommand('stop')} 
          onMouseEnter={() => setHoverStop(true)}
          onMouseLeave={() => setHoverStop(false)}
          style={stopStyle}
        >
          <span style={{ fontSize: '18px' }}>■</span> Stop Bot
        </button>

      </div>
    </div>
  );
};